import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import SelectDeps from '@/pages/storage/Content/SelectDeps';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, StorageObjectEditorModelState } from '@/models/connect';
import {
  ChangeAction,
  OnChangeTypeAction,
  OnClick_SaveBtn_Action,
} from '@/models/storageObjectEditor';
import DepsCards from './DepsCards';
import FFormLayout from '@/components/FFormLayout';
import FDrawer from '@/components/FDrawer';
import { history } from 'umi';
import FTooltip from '@/components/FTooltip';
import { FUtil, FServiceAPI, FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FResourceOptions from '@/components/FResourceOptions';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import FResourceTypeInput4 from '@/components/FResourceTypeInput4';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';

interface DetailsProps {
  dispatch: Dispatch;
  storageObjectEditor: StorageObjectEditorModelState;
}

function Details({ storageObjectEditor, dispatch }: DetailsProps) {
  const [depInfoVisible, setDepInfoVisible] = React.useState<boolean>(false);

  async function onChange(payload: ChangeAction['payload']) {
    await dispatch<ChangeAction>({
      type: 'storageObjectEditor/change',
      payload,
    });
  }

  async function onClick_addOptionBtn() {
    const dataSource: {
      key: string;
      name: string;
      type: 'input' | 'select';
      input: string;
      select: string[];
      description: string;
    } | null = await fResourceOptionEditor({
      disabledKeys: [
        ...storageObjectEditor.systemProperties.map<string>((sp) => sp.key),
        ...storageObjectEditor.customProperties.map<string>((pp) => pp.key),
        ...storageObjectEditor.customConfigurations.map<string>((pp) => pp.key),
      ],
      disabledNames: [
        ...storageObjectEditor.systemProperties.map<string>((sp) => sp.name),
        ...storageObjectEditor.customProperties.map<string>((pp) => pp.name),
        ...storageObjectEditor.customConfigurations.map<string>((pp) => pp.name),
      ],
    });

    if (!dataSource) {
      return;
    }

    await onChange({
      customConfigurations: [...storageObjectEditor.customConfigurations, dataSource],
    });
  }

  return (
    <FDrawer
      destroyOnClose={true}
      title={'编辑对象信息'}
      open={storageObjectEditor.objectId !== ''}
      width={720}
      topRight={
        <Space size={30}>
          <FComponentsLib.FTextBtn
            onClick={() => {
              history.replace(
                FUtil.LinkTo.storageSpace({
                  bucketName: storageObjectEditor.bucketName,
                }),
              );
            }}
            type='default'
          >
            取消
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FRectBtn
            // disabled={hasError}
            onClick={async () => {
              dispatch<OnClick_SaveBtn_Action>({
                type: 'storageObjectEditor/onClick_SaveBtn',
              });
            }}
          >
            保存
          </FComponentsLib.FRectBtn>
        </Space>
      }
      onClose={() => {
        history.replace(
          FUtil.LinkTo.storageSpace({
            bucketName: storageObjectEditor.bucketName,
          }),
        );
      }}
      getContainer={() => {
        return self.document.body;
      }}
    >
      <div className={styles.divContainer}>
        <FFormLayout>
          <FFormLayout.FBlock title={'对象'}>
            <div className={styles.Header}>
              <Space size={10}>
                <FComponentsLib.FContentText
                  text={`${storageObjectEditor.bucketName}/${storageObjectEditor.objectName}`}
                  type='highlight'
                  className={styles.objectName}
                  singleRow
                />
              </Space>
              <Space size={15}>
                <FCopyToClipboard
                  iconStyle={{ fontSize: 14 }}
                  text={`${storageObjectEditor.bucketName}/${storageObjectEditor.objectName}`}
                  title={FI18n.i18nNext.t('copy_object_name')}
                />
                <FTooltip title={FI18n.i18nNext.tAuto('tip_download_object')}>
                  <div>
                    <FComponentsLib.FTextBtn
                      type='primary'
                      onClick={() => {
                        FServiceAPI.Storage.downloadObject({
                          objectIdOrName: encodeURIComponent(
                            `${storageObjectEditor.bucketName}/${storageObjectEditor.objectName}`,
                          ),
                        });
                      }}
                    >
                      <FIcons.FDownload style={{ fontSize: 14 }} />
                    </FComponentsLib.FTextBtn>
                  </div>
                </FTooltip>
              </Space>
            </div>
            <div style={{ height: 5 }} />

            <div className={styles.attributes}>
              <div style={{ height: 20 }} />
              <div className={styles.attributesHeader}>
                <FComponentsLib.FContentText
                  text={'基础属性'}
                  type={'highlight'}
                  style={{ fontSize: 12 }}
                />
                <div>
                  <Space size={20}>
                    <FComponentsLib.FTextBtn
                      style={{ fontSize: 12, fontWeight: 600 }}
                      type='primary'
                      onClick={async () => {
                        const dataSource: {
                          key: string;
                          name: string;
                          description: string;
                        } | null = await fResourcePropertyEditor3({
                          disabledKeys: [
                            ...storageObjectEditor.systemProperties.map<string>((sp) => sp.key),
                            ...storageObjectEditor.customProperties.map<string>((pp) => pp.key),
                            ...storageObjectEditor.customConfigurations.map<string>((pp) => pp.key),
                          ],
                          disabledNames: [
                            ...storageObjectEditor.systemProperties.map<string>((sp) => sp.name),
                            ...storageObjectEditor.customProperties.map<string>((pp) => pp.name),
                            ...storageObjectEditor.customConfigurations.map<string>(
                              (pp) => pp.name,
                            ),
                          ],
                        });
                        if (!dataSource) {
                          return;
                        }

                        onChange({
                          customProperties: [
                            ...storageObjectEditor.customProperties,
                            {
                              ...dataSource,
                              value: '',
                            },
                          ],
                        });
                      }}
                    >
                      {FI18n.i18nNext.tAuto('resourceinfo_add_btn')}
                    </FComponentsLib.FTextBtn>
                  </Space>
                </div>
              </div>

              <div style={{ height: 20 }} />

              {storageObjectEditor.systemProperties.length === 0 &&
                storageObjectEditor.customProperties.length === 0 && (
                  <>
                    <div style={{ height: 10 }} />
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.tAuto('resourceinfo_empty_msg')}
                        type={'additional2'}
                        style={{ maxWidth: 600, textAlign: 'center' }}
                      />
                    </div>
                    <div style={{ height: 20 }} />
                  </>
                )}
              {!(
                storageObjectEditor.systemProperties.length === 0 &&
                storageObjectEditor.customProperties.length === 0
              ) && (
                <>
                  <FAttrsAndConfigs
                    itemWidth={'100%'}
                    dateSource={[
                      ...storageObjectEditor.systemProperties.map<IAttrsAndConfigsItem>((sp) => {
                        return {
                          key: sp.key,
                          value: sp.value,
                          name: sp.name,
                          description: sp.description,
                          configs: {
                            item_Deletable: false,
                            key_Editable: false,
                            name_Editable: false,
                            description_Editable: false,
                            value_Editable: (sp.type === 'additional' && sp.valueConfig) || false,
                          },
                        };
                      }),
                      ...storageObjectEditor.customProperties.map<IAttrsAndConfigsItem>((cp) => {
                        return {
                          key: cp.key,
                          value: cp.value,
                          name: cp.name,
                          description: cp.description,
                          configs: {
                            item_Deletable: true,
                            key_Editable: true,
                            name_Editable: true,
                            description_Editable: true,
                            value_Editable: {
                              text: {
                                nullable: true,
                                minLength: 0,
                                maxLength: 100,
                              },
                            },
                          },
                        };
                      }),
                    ]}
                    onChangeItem={(oldData, newData, index) => {
                      if (index < storageObjectEditor.systemProperties.length) {
                        const newDateSource = [...storageObjectEditor.systemProperties];
                        newDateSource[index] = {
                          key: newData.key,
                          name: newData.name,
                          value: newData.value,
                          description: newData.description,
                          type: storageObjectEditor.systemProperties[index].type,
                          valueConfig: storageObjectEditor.systemProperties[index].valueConfig,
                        };

                        onChange({
                          systemProperties: newDateSource,
                        });
                      } else {
                        const newDateSource = [...storageObjectEditor.customProperties];
                        newDateSource[index - storageObjectEditor.systemProperties.length] = {
                          key: newData.key,
                          name: newData.name,
                          value: newData.value,
                          description: newData.description,
                        };

                        onChange({
                          customProperties: newDateSource,
                        });
                      }
                    }}
                    onDeleteItem={(value) => {
                      onChange({
                        customProperties: storageObjectEditor.customProperties.filter((cp) => {
                          return cp.key !== value.key && cp.name !== value.name;
                        }),
                      });
                    }}
                    disabledKeys={[
                      ...storageObjectEditor.systemProperties.map<string>((rp) => rp.key),
                      ...storageObjectEditor.customProperties.map<string>((cp) => cp.key),
                      ...storageObjectEditor.customConfigurations.map<string>((cp) => cp.key),
                    ]}
                    disabledNames={[
                      ...storageObjectEditor.systemProperties.map<string>((rp) => rp.name),
                      ...storageObjectEditor.customProperties.map<string>((cp) => cp.name),
                      ...storageObjectEditor.customConfigurations.map<string>((cp) => cp.name),
                    ]}
                  />
                </>
              )}

              <div style={{ height: 15 }} />
            </div>
            {storageObjectEditor.resourceTypeConfig.isSupportOptionalConfig && (
              <>
                <div style={{ height: 5 }} />

                {storageObjectEditor.customConfigurations.length === 0 ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      gap: 20,
                    }}
                  >
                    <FComponentsLib.FTextBtn
                      type={'default'}
                      style={{ fontSize: 12 }}
                      onClick={() => {
                        onClick_addOptionBtn();
                      }}
                    >
                      添加可选配置
                    </FComponentsLib.FTextBtn>
                  </div>
                ) : (
                  <div className={styles.options}>
                    <div style={{ height: 20 }} />
                    <div className={styles.optionsHeader}>
                      <FComponentsLib.FContentText
                        text={'可选配置'}
                        type={'highlight'}
                        style={{ fontSize: 12 }}
                      />

                      <FComponentsLib.FTextBtn
                        style={{ fontSize: 12, fontWeight: 600 }}
                        type='primary'
                        onClick={async () => {
                          onClick_addOptionBtn();
                        }}
                      >
                        添加配置
                      </FComponentsLib.FTextBtn>
                    </div>
                    <div style={{ height: 20 }} />

                    <FResourceOptions
                      dataSource={storageObjectEditor.customConfigurations}
                      onEdit={async (value) => {
                        const index: number = storageObjectEditor.customConfigurations.findIndex(
                          (p) => {
                            return p === value;
                          },
                        );

                        const dataSource: {
                          key: string;
                          name: string;
                          type: 'input' | 'select';
                          input: string;
                          select: string[];
                          description: string;
                        } | null = await fResourceOptionEditor({
                          disabledKeys: [
                            ...storageObjectEditor.systemProperties.map<string>((sp) => sp.key),
                            ...storageObjectEditor.customProperties.map<string>((pp) => pp.key),
                            ...storageObjectEditor.customConfigurations.map<string>((pp) => pp.key),
                          ],
                          disabledNames: [
                            ...storageObjectEditor.systemProperties.map<string>((sp) => sp.name),
                            ...storageObjectEditor.customProperties.map<string>((pp) => pp.name),
                            ...storageObjectEditor.customConfigurations.map<string>(
                              (pp) => pp.name,
                            ),
                          ],
                          defaultData: value,
                        });

                        if (!dataSource) {
                          return;
                        }

                        await onChange({
                          customConfigurations: storageObjectEditor.customConfigurations.map(
                            (a, b) => {
                              if (b !== index) {
                                return a;
                              }
                              return dataSource;
                            },
                          ),
                        });
                      }}
                      onDelete={async (value) => {
                        await onChange({
                          customConfigurations: storageObjectEditor.customConfigurations.filter(
                            (a) => {
                              return a.key !== value.key && a.name !== value.name;
                            },
                          ),
                        });
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </FFormLayout.FBlock>
          <FFormLayout.FBlock title={'资源类型'}>
            <FResourceTypeInput4
              width={360}
              value={storageObjectEditor.resourceTypeValue}
              onChange={(value) => {
                dispatch<OnChangeTypeAction>({
                  type: 'storageObjectEditor/onChangeType',
                  payload: {
                    value: value,
                  },
                });
              }}
              showAddNewType={false}
            />
          </FFormLayout.FBlock>
          <FFormLayout.FBlock title={'依赖'}>
            <Space size={10}>
              <FComponentsLib.FRectBtn type='default' onClick={() => setDepInfoVisible(true)}>
                添加依赖
              </FComponentsLib.FRectBtn>
            </Space>
            {storageObjectEditor.depRs.length > 0 && (
              <DepsCards
                title={'资源'}
                dataSource={storageObjectEditor.depRs}
                onChange={(value) => {
                  dispatch<ChangeAction>({
                    type: 'storageObjectEditor/change',
                    payload: {
                      depRs: value as StorageObjectEditorModelState['depRs'],
                    },
                  });
                }}
              />
            )}

            {storageObjectEditor.depOs.length > 0 && (
              <DepsCards
                title={'对象'}
                dataSource={storageObjectEditor.depOs}
                onChange={(value) => {
                  dispatch<ChangeAction>({
                    type: 'storageObjectEditor/change',
                    payload: {
                      depOs: value as StorageObjectEditorModelState['depOs'],
                    },
                  });
                }}
              />
            )}
          </FFormLayout.FBlock>
        </FFormLayout>

        <FDrawer
          title='添加依赖'
          width={700}
          open={depInfoVisible}
          onClose={() => setDepInfoVisible(false)}
          destroyOnClose
        >
          <SelectDeps />
        </FDrawer>
      </div>
    </FDrawer>
  );
}

export default connect(({ storageObjectEditor }: ConnectState) => ({
  storageObjectEditor: storageObjectEditor,
}))(Details);
